import styled from "styled-components";

export const MainDash = styled.main`
    display: flex;
    flex-direction: column;
    text-align: left;
    background-color: #121214;
    margin-top: 30px;
    width: 90%;

    h3{
        font-weight: 700;
        font-size: 18px;
        color: #F8F9FA;
    }

    p{
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
    }
    .headerListTechs{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 32px;
        align-items: center;
        margin-bottom: 15px;
        button{
            width: 32px;
            height: 32px;
            border-radius: 4px;
            background-color: #212529;
            color: #FFFFFF;
            border: none;
            font-size: 20px;
            font-weight: bold;
            cursor: pointer;
        :hover{
                background-color: #868E96;
            }
        }
    }
    .conteinerListTechs{
        display: flex;
        flex-direction: row;
        width: 98%;
        background-color: #212529;
        border-radius: 4px;
        padding: 10px;
        justify-content: space-between;

    }
    .trashTech{
        background-color: #121214;
        color: #ffff;
        border: none;
        cursor: pointer;

    }
    @media screen and (min-width: 790px){
        width: 780px;
    }

`